// extracted by mini-css-extract-plugin
module.exports = {"information":"index-module--information--wI1hf","scroll":"index-module--scroll--2aYLM","textJa":"index-module--text-ja--oo003","textEn":"index-module--text-en--3CNF3"};